<template>
  <div>
    <Modal
      :fullscreen="isFullScreen"
      v-model="isShow"
      :draggable="true"
      transfer
      :title="tagName"
      :footer-hide="footerHide"
      :z-index="zIndex"
      :mask-closable="false"
      :styles="{top: '10%'}"
      @on-ok="onOk"
      @on-cancel="onCancel"
      :width="modalWidth"
    >
      <div :style="styleList">
        <!-- 表单 strat -->
        <div v-if="isLandscape">
          切换历史：
          <Select
            v-model="selectValue"
            style="width: 70px; margin-right: 5px"
            @on-change="onSelect"
            :disabled="isSelect"
          >
            <Option
              v-for="item in cityList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}
            </Option>
          </Select>
          开始时间：
          <DatePicker
            type="datetime"
            v-model="startTime"
            :disabled="isdisabled"
            style="width: 130px; margin-right: 0px"
          ></DatePicker>
          结束时间：
          <DatePicker
            type="datetime"
            v-model="endTime"
            :disabled="isdisabled"
            style="width: 130px; margin-right: 0px"
          ></DatePicker>
          <InputNumber
            :min="1"
            v-model="InputNumber"
            :disabled="isdisabled"
            style="width: 40px"
          ></InputNumber>
          <Select v-model="model1" :disabled="isdisabled" style="width: 50px">
            <Option v-for="k in time" :value="k.value" :key="k.value">{{
              k.label
            }}</Option>
          </Select>
          <Button type="primary" :disabled="isdisabled" @click="onGteHistory">
            查询
          </Button>
        </div>
        <div v-if="isPorTrait">
            <table style="width: 100%">
                <!-- 第一行 -->
                <tr>
                    <td>切换历史：</td>
                    <td>
                        <Select 
                            v-model="selectValue"
                            style="width: 70px; margin-right: 5px"
                            @on-change="onSelect"
                            :disabled="isSelect"
                            >
                            <Option
                                v-for="item in cityList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}
                            </Option>
                        </Select>
                    </td>
                    <td>开始时间：</td>
                    <td>
                        <DatePicker
                            type="datetime"
                            v-model="startTime"
                            :disabled="isdisabled"
                            style="width: 130px; margin-right: 0px"
                        ></DatePicker>
                    </td>
                </tr>
                <!-- 第二行 -->
                <tr>
                    <td>
                        时间间隔：
                    </td>
                    <td>
                        <InputNumber
                            :min="1"
                            v-model="InputNumber"
                            :disabled="isdisabled"
                            style="width: 40px"
                        ></InputNumber>
                        <Select v-model="model1" :disabled="isdisabled" style="width: 50px">
                            <Option v-for="k in time" :value="k.value" :key="k.value">{{ k.label}}</Option>
                        </Select>
                    </td>
                    <td>结束时间：</td>
                    <td>
                        <DatePicker
                            type="datetime"
                            v-model="endTime"
                            :disabled="isdisabled"
                            style="width: 130px; margin-right: 0px"
                        ></DatePicker>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><Button type="primary" :disabled="isdisabled" @click="onGteHistory">
            查询
          </Button></td>
                </tr>
            </table>
          
        </div>
        <!-- 表单  end-->
        <!-- 点信息 start -->
        <div id="list" v-show="isList"></div>
        <!-- 电信息 end -->
        <!-- 曲线 start -->
        <div id="chartmain" :style="styleCurve" v-show="isCurve"></div>
        <!-- 曲线 end -->
      </div>
      <div slot="footer">
        <Button type="primary" @click="onOk">关闭</Button>
      </div>
    </Modal>
    <div v-if="isEnable" :style="enableStyle"></div>
  </div>
</template>
<style>
.ivu-modal-header-inner {
  text-align: center;
}
</style>

<script>
import Vue from "vue";
import fvSystemApi from "../../js/fvSystemApi";

export default {
  name: "fvTextExtend",
  props: ["primitives", "fvSystemApi", "parentName"],
  mounted: function () {
    this.$store.registerModule(["system", "fvTextExtend"], {
      state: {
        $: this,
      },
    });
    this.chartObject = this.$echarts.init(document.getElementById("chartmain"));
    window.addEventListener(
      "resize",
      () => {
        // 判断横竖屏
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        if (width > height && window.isApp) {
          this.isIphone();
          this.isLandscape = true;
          this.isPorTrait = false;
        } else if (width < height && window.isApp) {
          this.isIphone();
          this.isLandscape = false;
          this.isPorTrait = true;
        }
        // 做页面适配
        // 注意：renderResize 方法执行时虚拟 dom 尚未渲染挂载，如果要操作 vue 实例，最好在this.$nextTick()里进行。
      },
      false
    );
    this.isIphone();
  },
  data: function () {
    return {
      isLandscape: true, // 横屏
      isPorTrait: false, // 竖屏
      InputNumber: 1,
      model1: "秒",
      time: [
        {
          value: "日",
          label: "日",
        },
        {
          value: "时",
          label: "时",
        },
        {
          value: "分",
          label: "分",
        },
        {
          value: "秒",
          label: "秒",
        },
      ],
      isOpen: false,
      //开始时间
      startTime: "",
      //结束时间
      endTime: "",
      //时间禁用
      isdisabled: true,
      //下拉框禁用
      isSelect: false,
      //是否可用
      isEnable: false,
      zIndex: 9999,
      isShow: false,
      tagName: "   ",
      footerHide: false,
      chartObject: null,
      isCurve: false, //显示曲线
      isList: false, //显示实时表
      isokko: true, //单点趋势标记
      newtt: [],
      optionSeriesData: [],
      cityList: [
        {
          value: "0",
          label: "实时",
        },
        {
          value: "1",
          label: "历史",
        },
      ],
      //下拉框值
      selectValue: "0",
      option: {
        //初始化曲线
        legend: {
          data: [],
          // orient:'vertical',
          right: 0,
          top: 20,
          textStyle: {
            fontSize: 10,
          },
          selected: {},
        },
        tooltip: {
          show: true,
          trigger: "axis",
          //修改悬浮窗的触发事件
          // triggerOn: 'click',//mousemove|click
          //alwaysShowContent:true,//悬浮框是始终显示
          axisPointer: {
            animation: false,
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            splitNumber: 12,
            data: [],
          },
        ],
        yAxis: {},
        series: [
          {
            name: "值",
            type: "line",
            showSymbol: false,
            hoverAnimation: false,
            data: [],
          },
        ],
      },
      styleList: {
        //报表展示样式

        width: "750px",
        // height: '35px',
      },
      styleLists: {
        width: "750px",
        height: "35px",
        lineHeight: "35px",
      },
      styleCurve: {
        //曲线展示样式
        width: "750px",
        height: "280px",
        // position: 'absolute',
        // left: '5%',
        // top: '22%'
      },
      modalWidth: 810, //弹窗宽度
      historyTimeData: [], //历史数据时间
      historyData: [], //历史数据

      realTimeData: [], //实时数据时间
      realData: [], //实时数据
      isFullScreen: false, // 是否全屏
    };
  },
  methods: {
    gettimeStep() {
      var currentTime = 0;
      switch (this.model1) {
        case "秒":
          currentTime = this.InputNumber;
          break;
        case "分":
          currentTime = this.InputNumber * 60;
          break;
        case "时":
          currentTime = this.InputNumber * 3600;
          break;
        case "日":
          currentTime = this.InputNumber * 86400;
          break;
      }
      return currentTime;
    },
    //查询历史
    onGteHistory() {
		var timeStep = this.gettimeStep();
		//标记实时值不再刷新
		this.isOpen = true;
		//判断如果时间间隔数据大于3600 个点 重新计算时间间隔请求数据
		var step =(new Date(this.endTime).getTime() / 1000 -new Date(this.startTime).getTime() / 1000) /timeStep;
		if (step > 3600) {
			var timeStep = parseInt((new Date(this.endTime).getTime() / 1000 -new Date(this.startTime).getTime() / 1000) /3600);
		}
		var data = {
			head: "dataLayer",
			message: {
				head: "getHisData",
				varList: [this.varListName.split("$").join("")], //修改$符号
				startTime: new Date(this.startTime).getTime(),
				endTime: new Date(this.endTime).getTime(),
				hisType: 0,
				hisStep: timeStep, //时间间隔
			},
		};
    	this.$store.state.system.$.getHistory(data).then((response) => {
			this.historyData = [];
			this.historyTimeData = [];
			for (var k in response.varList[0].valueList) {
				this.historyData.push(Math.floor(response.varList[0].valueList[k].PV * Math.pow(10, 4) ) / Math.pow(10, 4));
				this.historyTimeData.push(this.timestampToTime(response.varList[0].valueList[k].TIME));
			}
			this.option.xAxis[0].data = this.historyTimeData;
			this.option.series[0].data = this.historyData;
			this.chartObject.setOption(this.option);
        }).catch((error) => {
			if(error.error == "获取历史请求较多，请等待"){
				setTimeout(()=>{
					this.getHistorys(data);
				},1000)
			}else{
				console.log("失败：" + error);
			}
        });
    },
	getHistorys(data){
		this.$store.state.system.$.getHistory(data).then((response) => {
			this.historyData = [];
			this.historyTimeData = [];
			for (var k in response.varList[0].valueList) {
				this.historyData.push(Math.floor(response.varList[0].valueList[k].PV * Math.pow(10, 4)) / Math.pow(10, 4));
				this.historyTimeData.push(this.timestampToTime(response.varList[0].valueList[k].TIME));
			}
			this.option.xAxis[0].data = this.historyTimeData;
			this.option.series[0].data = this.historyData;
			this.chartObject.setOption(this.option);
		}).catch((error) => {
			if(error.error == "获取历史请求较多，请等待"){
				setTimeout(()=>{
					this.getHistorys(data);
				},1000)
			}else{
				console.log("失败：" + error);
			}
		});	
	},

    /*
            参数：   tagsStruct ：获取历史数据报文
            返回值： Promise对象
            说明：获取历史数据
            在API中有此方法， 因在api中图元调用不到， 临时使用此方法
        */
    getHistory(tagsStruct) {
      return new Promise((resolve, reject) => {
        this.$store.state.system.$.dbCom.sendMessage(
          tagsStruct,
          (err, result) => {
            if (err) {
              reject(err);
            } else {
              resolve(result);
            }
          }
        );
      });
    },
    //选中 下拉框
    onSelect: function () {
      if (this.selectValue == 0) {
        this.isdisabled = true;
        this.isOpen = false;
      } else {
        this.isdisabled = false;
      }
    },
    show: function (data, close) {
      this.$store.state.system.$.isZoom = false;
      //打开弹窗关闭方法缩小
      if (this.$store.state.system.dragResize.$.rawData.isdisplay == true) {
        this.$store.state.system.dragResize.$.isdisplay = false;
      }
      this.startTime = this.timestampToTime(new Date().getTime() - 300000);
      this.endTime = this.timestampToTime(new Date().getTime());
      // document.getElementById('list').style.color = data.borderColor;
      this.realTimeData = []; //实时数据时间
      this.realData = []; //实时数据
      this.isShow = true;
      this.isCurve = data.isShowCurve;
      this.isList = data.isShowPeport;
      this.isokko = true;
      this.close = close;
    },
    init(tagName) {
      this.chartObject.setOption(this.option, true);
    },
    /**
     * 作用：周期刷新实时值
     */
    newData(data, name) {
      if (data == undefined) return;
      if (name.indexOf("__systemMidVar") > -1) {
        name = name.substring(15, name.length - 6);
        this.tagName = "中间变量";
        this.isSelect = true;
      } else {
        this.isSelect = false;
        this.tagName = data.DESC || " ";
      }
      //用于使用如果中间变量是固定的数值拼接单点趋势
      if (typeof data != "object") {
        data = {
          DESC: "中间变量",
          INDEX: 0,
          NAME: name,
          PV: data,
          QUALITY: 192,
          TIME: new Date().getTime(),
        };
      }
      //判断是否启用单点趋势
      if (this.isEnable) return;
      if (this.isokko == true) {
        this.varListName = data.NAME;
        document.getElementById("list").innerHTML =
          "<div>点位名称：" +
          data.NAME.replace(/\./g, "\\") +
          ";&nbsp;&nbsp;&nbsp;&nbsp;点位描述：" +
          data.DESC +
          ";&nbsp;&nbsp;&nbsp;&nbsp;值：" +
          Math.floor(data.PV * Math.pow(10, 4)) / Math.pow(10, 4);
        +"</div>";
        this.realTimeData.push(this.timestampToTime(data.TIME)); //时间
        this.realData.push(data.PV); //数值
        if (this.realTimeData.length > 15) {
          this.realTimeData.shift();
        }
        if (this.realData.length > 15) {
          this.realData.shift();
        }
        //判断是否是历史还是实时
        if (this.isOpen) return;
        this.option.xAxis[0].data = this.realTimeData;
        this.option.series[0].data = this.realData;
        this.chartObject.setOption(this.option);
      }
    },
    onOk: function () {
      //打开弹窗关闭方法缩小
      if (this.$store.state.system.dragResize.$.rawData.isdisplay == true) {
        this.$store.state.system.dragResize.$.isdisplay = true;
      }
      this.close();
      this.isOpen = false;
      this.selectValue = "0";
      this.isokko = false;
      this.isShow = false;
      this.option.series[0].data = [];
      this.option.xAxis[0].data = [];
    },
    onCancel: function () {
      //打开弹窗关闭方法缩小
      if (this.$store.state.system.dragResize.$.rawData.isdisplay == true) {
        this.$store.state.system.dragResize.$.isdisplay = true;
      }
      this.close();
      this.isOpen = false;
      this.selectValue = "0";
      this.isokko = false;
      this.isShow = false;
      this.option.series[0].data = [];
      this.option.xAxis[0].data = [];
    },
    //时间转换
    timestampToTime: function (timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
      var h =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes()
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
    Enable: function (isEnable) {
      this.isEnable = isEnable ? false : true;
    },
    /*
            作用：判断是否是手机访问单点趋势
        */
    isIphone() {
      if (window.isApp()) {
          // 判断横竖屏
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        if (width > height && window.isApp) {
          this.isLandscape = true;
          this.isPorTrait = false;
        } else if (width < height && window.isApp) {
          this.isLandscape = false;
          this.isPorTrait = true;
        }
        this.changeWith();
        this.styleList = {
          //报表展示样式
          width: window.innerWidth - 10 + "px",
          height: "30px",
          fontSize: "10px",
        };
        this.styleCurve = {
          //曲线展示样式
          width: window.innerWidth - 10 + "px",
          height: window.innerHeight / 1.7 + "px",
          //   backgroundColor: "skyblue"
        };
        this.chartObject.resize({
          width: window.innerWidth - 10 + "px",
          height: window.innerHeight / 1.7 + "px",
        });
        // this.modalWidth = window.innerWidth;
        this.changeWith();
        this.isFullScreen = true;
      }
    },
    changeWith() {
      this.modalWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.modalWidth = document.body.clientWidth;
        })();
      };
    }
  },
  created() {
    //挂载
  },
};
</script>



// WEBPACK FOOTER //
// src/components/system/fvTextExtend.vue